import { render, staticRenderFns } from "./registration_form.vue?vue&type=template&id=1c4c954e&scoped=true&"
import script from "./registration_form.vue?vue&type=script&lang=js&"
export * from "./registration_form.vue?vue&type=script&lang=js&"
import style0 from "./registration_form.vue?vue&type=style&index=0&id=1c4c954e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c954e",
  null
  
)

export default component.exports